// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1ET3y","infoBtn":"quickbooks_infoBtn__2GGLw","formBox":"quickbooks_formBox__2_z8G","formFooter":"quickbooks_formFooter__2SQaD"};